/**
 * Determines the appropriate Kind based on JCAMP data
 * @param data - JCAMP entry data
 * @returns The appropriate Kind or undefined
 */
export function getJcampKind(data) {
    if (!data.dataType || !data.spectra?.[0]?.yUnits) {
        return undefined;
    }
    const dataType = data.dataType.toLowerCase();
    const yUnits = data.spectra[0].yUnits.toLowerCase();
    if (dataType.match(/infrared/)) {
        if (yUnits.match(/absorbance/)) {
            return IR_ABSORBANCE;
        }
        else {
            return IR_TRANSMITTANCE;
        }
    }
    return undefined;
}
export const IR_TRANSMITTANCE = {
    normalization: {},
    importation: {
        converter: (transmittance) => -Math.log10(transmittance),
    },
    kind: 'Infrared',
    display: {
        xLabel: 'wavelength [cm-1]',
        xInverted: true,
        yLabel: 'Absorbance',
    },
};
export const IR_ABSORBANCE = {
    normalization: {},
    kind: 'Infrared',
    display: {
        xLabel: 'wavelength [cm-1]',
        xInverted: true,
        yLabel: 'Absorbance',
    },
};
export const nmr1H = {
    display: {
        xLabel: 'δ [ppm]',
        xInverted: true,
        yLabel: 'Intensity',
    },
};
export const nmr13C = {
    display: {
        xLabel: 'δ [ppm]',
        xInverted: true,
        yLabel: 'Intensity',
    },
};
//# sourceMappingURL=Kinds.js.map